import { render, staticRenderFns } from "./AccessOptions.vue?vue&type=template&id=3126e4bd&"
import script from "./AccessOptions.vue?vue&type=script&lang=js&"
export * from "./AccessOptions.vue?vue&type=script&lang=js&"
import style0 from "./AccessOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports